"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxRightSide/Chat.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _error = require('shared/services/error');
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');
var _useOnRemovedFromChat = require('shared/hooks/inbox/useOnRemovedFromChat');



var _blobject = require('shared/selectors/blobject');

var _Header = require('web/components/RightSide/Header');
var _RightSide = require('web/components/RightSide');
var _ChatHeader = require('../ChatHeader'); var _ChatHeader2 = _interopRequireDefault(_ChatHeader);
var _ConversationScreen = require('web/screens/ConversationScreen'); var _ConversationScreen2 = _interopRequireDefault(_ConversationScreen);
var _ChatParticipantsList = require('web/screens/Inbox/ChatParticipantsList'); var _ChatParticipantsList2 = _interopRequireDefault(_ChatParticipantsList);
var _ChatSearchPane = require('web/screens/Inbox/ChatSearchPane'); var _ChatSearchPane2 = _interopRequireDefault(_ChatSearchPane);







const Chat = ({ blobjectKey, isHidden = false }) => {
  const selectBlobjectSubscriberCounts = _react.useMemo.call(void 0, _blobject.makeSelectBlobjectSubscriberCounts, [])
  const subscribersCount = _hooks.useAppSelector.call(void 0, 
    state => selectBlobjectSubscriberCounts(state, blobjectKey).totalCount,
  )
  const isBlobjectLoaded = _hooks.useAppSelector.call(void 0, state => !!_blobject.selectBlobjectByKey.call(void 0, state, blobjectKey))
  const conversationKey = _hooks.useAppSelector.call(void 0, state => _optionalChain([_blobject.selectBlobjectByKey.call(void 0, state, blobjectKey), 'optionalAccess', _ => _.WrappedKey]))
  const conversationType = _hooks.useAppSelector.call(void 0, state => _optionalChain([_blobject.selectBlobjectByKey.call(void 0, state, blobjectKey), 'optionalAccess', _2 => _2.WrappedType]))

  const [openPane, setOpenPane] = _react.useState(null)
  // Once opened, the search pane stays mounted so closing it — including the
  // automatic close after jumping to a result on a narrow viewport — keeps the
  // query and results for when the user opens search again.
  const [hasOpenedSearch, setHasOpenedSearch] = _react.useState.call(void 0, false)
  const handleToggleRightPane = _react.useCallback.call(void 0, 
    () => { setOpenPane(x => x === 'participants' ? null : 'participants') },
    [],
  )
  const handleToggleSearchPane = _react.useCallback.call(void 0, 
    () => {
      setOpenPane(x => x === 'search' ? null : 'search')
      setHasOpenedSearch(true)
    },
    [],
  )
  const handleCloseSearchPane = _react.useCallback.call(void 0, () => setOpenPane(null), [])

  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  _react.useEffect.call(void 0, 
    () => {
      if (!blobjectKey) return
      _actions2.default.getBlobjectDeep({ BKey: blobjectKey })
        .catch((e) => {
          if (!_error.isUnauthorizedError.call(void 0, e)) {
            showWarningBar('Failed to load conversation. Please try again.')
            return
          }
          // e.g. reopened after you were removed: there's nothing to show.
          showWarningBar("You don't have access to this chat")
          _actions2.default.gotoInbox()
        })
    },
    [blobjectKey, showWarningBar],
  )

  // Removed from this chat while it's open: the store drops it, which would
  // leave an empty pane.
  const handleRemoved = _react.useCallback.call(void 0, 
    () => {
      showWarningBar('You were removed from this chat')
      _actions2.default.gotoInbox()
    },
    [showWarningBar],
  )
  _useOnRemovedFromChat.useOnRemovedFromChat.call(void 0, blobjectKey, handleRemoved)

  _react.useEffect.call(void 0, 
    () => {
      // TODO: is this right?
      if (isBlobjectLoaded && !subscribersCount) _actions2.default.resumeLatestChat()
    },
    [isBlobjectLoaded, subscribersCount],
  )

  if (
    !blobjectKey ||
    !conversationType ||
    !conversationKey ||
    !isBlobjectLoaded
  ) return null

  return (
    _react2.default.createElement(_RightSide.RightSide, {
      inView: true,
      className: `right-side--chat${isHidden ? ' right-side---hidden' : ''}`,
      'aria-hidden': isHidden || undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}

      , _react2.default.createElement(_Header.RightSideHeader, { className: "chat-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}
        , _react2.default.createElement(_ChatHeader2.default, {
          blobjectKey: blobjectKey,
          rightPaneOpen: openPane === 'participants',
          onToggleRightPane: handleToggleRightPane,
          searchPaneOpen: openPane === 'search',
          onToggleSearchPane: handleToggleSearchPane, __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}
        )
      )
      , _react2.default.createElement(_RightSide.RightSideBody, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}
        , _react2.default.createElement(_ConversationScreen2.default, {
          blobjectKey: blobjectKey,
          conversationKey: conversationKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}}
        )
        , _react2.default.createElement(_RightSide.RightSidePane, { open: openPane === 'participants', __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}}
          , _react2.default.createElement(_Header.RightSideHeader, { className: "blmh-desktop-hide", __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}
            , _react2.default.createElement(_Header.HeaderMobileBackButton, { onClick: handleToggleRightPane, __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}} )
            , _react2.default.createElement(_Header.RightSideHeaderHeading, { title: "Participants", __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}} )
          )
          , _react2.default.createElement(_ChatParticipantsList2.default, { blobjectKey: blobjectKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}} )
        )
        , _react2.default.createElement(_RightSide.RightSidePane, { open: openPane === 'search', __self: this, __source: {fileName: _jsxFileName, lineNumber: 125}}
          , hasOpenedSearch && (
            // Keyed by conversation: Chat is not re-keyed when blobjectKey
            // changes, so without this the previous chat's results would
            // survive into the next one.
            _react2.default.createElement(_ChatSearchPane2.default, {
              key: conversationKey,
              isOpen: openPane === 'search',
              conversationKey: conversationKey,
              conversationType: conversationType,
              blobjectKey: blobjectKey,
              onClose: handleCloseSearchPane, __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}}
            )
          )
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, Chat)
